import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';
import socket from 'config/socket';

import {
  GET_SALES_ORDERS, ADD_SALES_ORDER, UPDATE_SALES_ORDER_STATUS, UPDATE_SALES_ORDER_PRODUCT_STATUS, UPDATE_SALES_ORDER_PAYMENT, UPDATE_SALES_ORDER_PAY_DATE, SHALLOW_DELETE_SALES_ORDER
} from 'redux/actionTypes';
import { incrementIDGen, setNewSOStatus, setNewSOTotal, setNewSOPayments } from '.';
import { salesOrder } from 'constants/idGenType';
import { Created, Completed } from 'constants/status';

export const getSalesOrders = () => (dispatch, getState) => {
  axiosClient
    .get('/api/sales-orders', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_SALES_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const getSalesOrdersAdmin = () => (dispatch, getState) => {
  axiosClient
    .get('/api/sales-orders/admin', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_SALES_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addSalesOrder = (newSalesOrder, userId, adminId) => (dispatch, getState) => {
  axiosClient
    .post('/api/sales-orders', newSalesOrder, tokenConfig(getState))
    .then(res => {
      // Array creation to add new processes on the admin side.
      // To display the last process first, the resulting processArray is reversed.
      const processArray = res.data.products.map(product => ({
        id: product.id,
        displayId: product.displayId,
        userId: res.data.userId,
        salesOrderId: res.data.id,
        productId: product.productId,
        steps: []
      })).reverse();

      dispatch(incrementIDGen({ id: userId, field: salesOrder }));

      dispatch(setNewSOStatus(Created));
      dispatch(setNewSOTotal(res.data.total));
      dispatch({
        type: ADD_SALES_ORDER,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('private-request', {
        request: 'add-so-processes',
        userId: adminId,
        data: { salesOrderInfo: res.data, processArray }
      });
    })
    .catch(err => console.log(err))
};

export const addSalesOrderSocket = newSalesOrder => ({
  type: ADD_SALES_ORDER,
  payload: newSalesOrder
});

export const updateSalesOrderStatus = (updatedStatus, adminId) => (dispatch, getState) => {
  axiosClient
    .patch('/api/sales-orders/status', updatedStatus, tokenConfig(getState))
    .then(res => {
      if(getState().newSalesOrder.displayId && res.data.status === Completed) dispatch(setNewSOStatus(Completed));
      dispatch({
        type: UPDATE_SALES_ORDER_STATUS,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('private-request', {
        request: 'update-so-status',
        userId: adminId,
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateSalesOrderProductStatus = (updatedProductStatus, adminId) => (dispatch, getState) => {
  axiosClient
    .patch('/api/sales-orders/prod-status', updatedProductStatus, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_SALES_ORDER_PRODUCT_STATUS,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('private-request', {
        request: 'update-so-prod-status',
        userId: adminId,
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateSalesOrderPayment = (updatedPayment, adminId) => (dispatch, getState) => {
  axiosClient
    .put('/api/sales-orders/payment', updatedPayment, tokenConfig(getState))
    .then(res => {
      dispatch(setNewSOPayments(res.data.payments));
      dispatch({
        type: UPDATE_SALES_ORDER_PAYMENT,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('private-request', {
        request: 'update-so-payment',
        userId: adminId,
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateSalesOrderPaymentDate = (updatedDate, adminId) => (dispatch, getState) => {
  axiosClient
    .patch('/api/sales-orders/pay-date', updatedDate, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_SALES_ORDER_PAY_DATE,
        payload: res.data
      });
      // Socket will only emit for standard users.
      socket.emit('private-request', {
        request: 'update-so-pay-date',
        userId: adminId,
        data: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateSalesOrderStatusSocket = salesOrderInfo => ({
  type: UPDATE_SALES_ORDER_STATUS,
  payload: salesOrderInfo
});

export const updateSalesOrderProductStatusSocket = soProductInfo => ({
  type: UPDATE_SALES_ORDER_PRODUCT_STATUS,
  payload: soProductInfo
});

export const updateSalesOrderPaymentSocket = salesOrderInfo => ({
  type: UPDATE_SALES_ORDER_PAYMENT,
  payload: salesOrderInfo
});

export const updateSalesOrderPaymentDateSocket = salesOrderInfo => ({
  type: UPDATE_SALES_ORDER_PAY_DATE,
  payload: salesOrderInfo
});

export const deleteSalesOrder = (id, adminId) => (dispatch, getState) => {
  axiosClient
    .delete('/api/sales-orders/shallow', { params: { id }, ...tokenConfig(getState) })
    .then(res => {
      if(res.status === 204) {
        dispatch({
          type: SHALLOW_DELETE_SALES_ORDER,
          payload: { id }
        });
        // Socket will only emit for standard users.
        socket.emit('private-request', {
          request: 'delete-so-processes',
          userId: adminId,
          data: id
        });
      }
    })
    .catch(err => console.log(err))
};

export const deleteSalesOrderSocket = id => ({
  type: SHALLOW_DELETE_SALES_ORDER,
  payload: { id }
});